import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-post",
  "use": "svg-post-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-post\">\n  <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n  <path transform=\"translate(3 3)\" d=\"M11.938 3.333v-2.5c0-.5-.325-.833-.813-.833H3.812C3.325 0 3 .333 3 .833v8.334c0 .5.325.833.813.833h7.312c.488 0 .813-.333.813-.833v-2.5L16 8.333V1.667l-4.063 1.666zM18 13v2h-6v-2h6zm-8.063 0v2H.063v-2h9.874zm8.032 4v2H6v-2h11.969zM4 17v2H-.016v-2H4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol